import { gql } from '@apollo/client';

export const FETCH_BULK_TRADE_REQUESTS_FOR_RUN = gql`
  query fetchBulkTradeRequestsForRun($input: FetchBulkTradeRequestsInput!) {
    fetchBulkTradeRequests(input: $input) {
      bulkTradeRequests {
        id
        state
        source
        sourceId
      }
      totalCount
    }
  }
`;

export const FETCH_SUB_TRADE_REQUESTS_FOR_RUN = gql`
  query fetchSubTradeRequestsForRun($input: FetchSubTradeRequestsInput!) {
    fetchSubTradeRequests(input: $input) {
      subTradeRequests {
        id
        state
        type
        isSellAll
        moneyAllocatedCents
        expectedQuantity
        expectedTradePriceCents
        currency
        portfolioReport
        settlementDays
        settlementDate
        verifiedAt
        blockedUntil
        blockedUntilAccountActive
        blockedUntilSubAccountActive
        schedule {
          id
          name
          nextDate
        }
        financialProduct {
          id
          ticker
          settlementDays
          currentPriceCents
          translatedName {
            en
          }
        }
        subAccount {
          id
          account {
            id
            type
            user {
              id
              firstName
              lastName
            }
          }
        }
      }
      totalCount
    }
  }
`;

export const BUCKET_SUB_TRADE_REQUESTS_FOR_RUN = gql`
  mutation bucketSubTradeRequestsForRun($input: BucketSubTradeRequestsInput!) {
    bucketSubTradeRequests(input: $input)
  }
`;

export const CANCEL_SUB_TRADE_REQUESTS_BY_ID = gql`
  mutation cancelSubTradeRequestsByIdForRun(
    $input: CancelSubTradeRequestsByIdInput!
  ) {
    cancelSubTradeRequestsById(input: $input)
  }
`;

export const VERIFY_SUB_TRADE_REQUESTS_FOR_RUN = gql`
  mutation verifySubTradeRequestsForRun($input: VerifySubTradeRequestsInput!) {
    verifySubTradeRequests(input: $input)
  }
`;
